import { render, staticRenderFns } from "./SoundSettings.vue?vue&type=template&id=1936fb4a&scoped=true"
import script from "./SoundSettings.vue?vue&type=script&lang=js"
export * from "./SoundSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1936fb4a",
  null
  
)

export default component.exports